import React from 'react'
import remark from 'remark'
import remarkHTML from 'remark-html'

export default function RenderedMarkdown({ rawMarkdown }) {
  const renderMarkdown = value => remark().use(remarkHTML).processSync(value).toString()

  return <span dangerouslySetInnerHTML={ { __html: renderMarkdown(rawMarkdown) } }></span>
}
